import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { DialogComponent } from "../common/DialogComponent";
import AlertDetails from "../Dialogs/AlertDetails";
import { useAreServicesActive } from "../../util/CommonServices";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../util/dateFormatting";

interface IProps {
    archivedAlerts: any;
    refresh: any;
}

const ArchivedAlerts = ({ archivedAlerts, refresh }: IProps) => {
    const { t: tLang } = useTranslation();
    const [showAlertDetails, setShowAlertDetails] = useState(false);
    const [yScroll, setYScroll] = useState(0);
    const [alert, setAlert] = useState({});
    const [years, setYears] = useState([]);
    const [types, setTypes] = useState([]);
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedType, setSelectedType] = useState("All");
    const [filteredArchive, setFilteredArchived]: any = useState([]);
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const isSocialMediaMonitoringActive = useAreServicesActive([idfServiceIds.socialMediaMonitoring, ezsServiceIds.socialMediaMonitoring]);

    const handleCloseDialog = (): any => {
        setShowAlertDetails(false);
        setTimeout(()=>{
            scrollTo(0, yScroll);
        })
    };

    useEffect(() => {
        setFilteredArchived(archivedAlerts);
        if (archivedAlerts.length > 0) {
            const year = archivedAlerts.map((alert: any) => alert.createdDate && alert.createdDate.split("/")[2]);
            setYears(
                year.filter(function (item: number, pos: number) {
                    return year.indexOf(item) === pos;
                })
            );
            const type = archivedAlerts.map((alert: any) => alert.alertCategory);
            setTypes(
                type.filter(function (item: number, pos: number) {
                    return !!item && type.indexOf(item) === pos;
                })
            );
        }
    }, [archivedAlerts]);

    const alertDetails = (alert: any) => {
        setAlert(alert);
        setYScroll(scrollY);
        setShowAlertDetails(true);
    };

    useEffect(() => {
        if (selectedYear === "All" && selectedType === "All") {
            setFilteredArchived(archivedAlerts);
        } else if (selectedYear === "All") {
            setFilteredArchived(archivedAlerts.filter((alert: any) => alert.alertCategory === selectedType));
        } else if (selectedType === "All") {
            setFilteredArchived(archivedAlerts.filter((alert: any) => alert.createdDate.split("/")[2] === selectedYear));
        } else {
            setFilteredArchived(archivedAlerts.filter((alert: any) => alert.createdDate.split("/")[2] === selectedYear && alert.alertCategory === selectedType));
        }
    }, [selectedYear, archivedAlerts, selectedType]);

    const selectYear = (e: any) => {
        setSelectedYear(e.target.value);
    };

    const needShowingCrossButton = (alrt: any): boolean => {
        return alrt["serviceType"] !== "SEXOFF-FWD";
    };

    return (
        <>
            <>
                <div className="row between-xs">
                    <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                        <h3 className="content-sub-title" id="archived-alerts-title">
                            {tLang("alerts.alerts.archivedAlertListTitle")} (<span id="archived-alert-count">{filteredArchive.length}</span>)
                        </h3>
                    </div>
                    <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                        <div className="form-row inline no-margin">
                            <div className="form-label">
                                <label htmlFor="archived-type" className="margin-right-xs">
                                    {tLang("alerts.alerts.filterLabelType")}
                                </label>
                            </div>
                            <div className="form-input">
                                <select className="inputbox" id="archived-type" onChange={(e) => setSelectedType(e.target.value)} name="archived-type">
                                    <option value="All">All</option>

                                    {types &&
                                        types.map((type: string) => {
                                            if (type === "Social") {
                                                return (
                                                    isSocialMediaMonitoringActive && (
                                                        <option key="Social" value="Social">
                                                            Social
                                                        </option>
                                                    )
                                                );
                                            } else {
                                                return (
                                                    <option key={type} value={type}>
                                                        {type}
                                                    </option>
                                                );
                                            }
                                        })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm col-no-gutter flex-grow-null">
                        <div className="form-row inline no-margin">
                            <div className="form-label">
                                <label htmlFor="archived-year" className="margin-right-xs">
                                    {tLang("alerts.alerts.filterLabel")}
                                </label>
                            </div>
                            <div className="form-input">
                                <select className="inputbox" id="archived-year" onChange={(e) => selectYear(e)} name="archived-year">
                                    <option value="All">All</option>
                                    {years.length > 0 &&
                                        years.map((year: number) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <ul id="archived-alerts-list">
                    {filteredArchive &&
                        filteredArchive.length > 0 &&
                        filteredArchive.map((alert: any, index: number) => (
                            <li key={index}>
                                <div className="monitoring-alert-container status-archived" onClick={() => alertDetails(alert)}>
                                    <a href="#" onClick={(e) => e.preventDefault()}>
                                        <span className="row">
                                            <span className="col-xs col-no-gutter flex-grow-null">
                                                <span className="monitoring-alert-icon">
                                                    <em className="las la-check-circle"></em>
                                                </span>
                                            </span>
                                            <span className="col-xs col-no-gutter">
                                                <span className="monitoring-alert-date">
                                                    <span className="sr-only">Alert Date:</span>
                                                    {alert.createdDate && getFormattedDate(i18nService.get("Country"), alert.createdDate)}
                                                </span>
                                                <span className="monitoring-alert-description">
                                                    <span className="sr-only">Archived Alert</span>
                                                    {(isBusinessUser ? "Business " : "") + alert.displayName}
                                                </span>
                                            </span>
                                        </span>
                                    </a>
                                </div>
                            </li>
                        ))}
                </ul>
            </>
            {showAlertDetails && (
                <DialogComponent
                    hideCloseButton={needShowingCrossButton(alert)}
                    dialogId="alert-details-dialog"
                    title="Alert Details"
                    closeDialog={handleCloseDialog}
                >
                    <AlertDetails refresh={refresh} alert={alert}></AlertDetails>
                </DialogComponent>
            )}
        </>
    );
};

export default ArchivedAlerts;
